import { useEffect } from 'react';

/** Keep the tab title in sync with the active section. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
